import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/Help";
import { useTranslation, Trans } from "react-i18next";
import { AccountDetailsLayout } from "@common/Layout/AccountDetailsLayout";
import { BarringList } from "@features/Barrings/BarringList";

export const BarringsPage = () => {
    const { t } = useTranslation("barrings");

    const toolTipText = (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Trans i18nKey="tooltipTextAllServiceBarring" ns="barrings" />
            </Grid>
        </Grid>
    );

    return (
        <AccountDetailsLayout
            requireNumberSelection
            selectYourNumberTitle={t("selectNumberTitle")}
            title={t("barMobileServices")}
        >
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <Typography align="center" gutterBottom>
                        <Trans i18nKey="barringDescription" ns="barrings" />
                        <Tooltip disableFocusListener disableTouchListener title={toolTipText}>
                            <HelpIcon />
                        </Tooltip>
                    </Typography>
                    <Typography align="center">
                        <Trans i18nKey="barringDescriptionWarning" ns="barrings" />
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <BarringList />
                </Grid>
            </Grid>
        </AccountDetailsLayout>
    );
};
